import { getLogger } from '@/lib/logger/logger';

const logger = getLogger('version');

/**
 * Fetch the current app version from public/version.txt without using cache.
 */
export const fetchAppVersion = async (): Promise<string> => {
  try {
    const url = `/version.txt?ts=${Date.now()}`; // cache-busting
    const res = await fetch(url, {
      cache: 'no-store',
      headers: {
        'Cache-Control': 'no-cache, no-store, must-revalidate',
        Pragma: 'no-cache',
        Expires: '0',
      },
    });
    if (!res.ok) {
      throw new Error(`HTTP ${res.status}`);
    }
    const text = await res.text();
    return text.trim();
  } catch (error) {
    logger.warn('[version] Failed to fetch version.txt:', error);
    return 'unknown';
  }
};

/**
 * Fetch and return the current app version silently (no console output).
 */
export const logAppVersion = async (): Promise<string> => {
  return fetchAppVersion();
};

/**
 * Expose a helper on the window object so developers can check the version via console.
 * Usage in console: showVersion()
 */
export const exposeVersionHelpers = (): void => {
  window.showVersion = async () => {
    const version = await fetchAppVersion();
    const mode = import.meta.env.MODE;
    // eslint-disable-next-line no-console
    console.log(`[${mode}] Version: ${version}`);
    return version;
  };
};
